export default {"src":"/_next/static/media/rocket.e6abe5cd.svg","height":57,"width":57};